<template>
  <div>
    <b-modal v-bind:visible="validationFailed && popupNotAlreadyShown"
             id="failed-validation-modal"
             ref="failed-validation-modal"
             centered
             hide-header
             ok-title="שלח"
             cancel-title="ביטול"
             footer-class="failed-validation-footer"
             @ok="submit"
             @hidden="registerAlreadyShown">
      <p class="text-center">תקלה אירעה כשניסינו לשמור את העבודה שלכם בזיכרון הדפדפן. <br />
        כדי שנוכל לנסות לשחזר את העבודה, הזינו את כתובת הדוא״ל שלכם (והעתיקו גם את הטקסט המקורי, אם אפשר).</p>
      <form id="failed-validation-contact-form" ref="failed-validation-contact-form" action="https://formspree.io/f/xvovdkvj" target="_blank" method="POST">
        <div>
          <b-form-group label="כתובת דוא״ל:" label-for="_replyto">
            <b-form-input v-model="email" required name="_replyto" type="email" />
            <b-form-invalid-feedback :force-show="submitClicked && !(email.includes('@'))">שדה חובה</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="הטקסט המקורי:" label-for="original_text">
            <textarea rows="3" class="form-control contact-form-control" name="original_text" type="text" />
          </b-form-group>
          <input type="hidden" name="validation_results_string" v-model="validationResultsString"/>
          <input type="hidden" name="saved_state_string" v-model="savedStateString"/>
        </div>
      </form>
    </b-modal>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'FailedValidationPopup',
  data () {
    return {
      email: '',
      submitClicked: false
    }
  },
  computed: {
    validationFailed () {
      return this.$store.state.validationResult && this.$store.state.validationResult.summary === 'failure'
    },
    validationResultsString () {
      return this.$store.state.validationResult ? JSON.stringify(this.$store.state.validationResult.failures) : undefined
    },
    savedStateString () {
      return this.$store.state.validationResult ? this.$store.state.validationResult.savedStateString : undefined
    },
    popupNotAlreadyShown () {
      return this.$store.state.validationResult && !(this.$store.state.validationResult.popupShown)
    },
  },
  methods: {
    submit (bvModalEvt) {
      this.submitClicked = true
      bvModalEvt.preventDefault()
      if (this.$refs['failed-validation-contact-form'].checkValidity()) {
        this.$refs['failed-validation-contact-form'].submit()
        this.$nextTick(() => {
          this.$refs['failed-validation-modal'].hide()
        })
      }
    },
    registerAlreadyShown () {
      this.$store.commit('VALIDATION_FAILURE_POPUP_SHOWN')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
